<template>
  <div class="com-card">
    <div class="com-card-title">{{ payload.name }}<span class="right-txt">¥{{ payload.price }}/对</span></div>
    <div class="com-card-content">
      <div class="text-wrap com-text-justify">
        <div v-html="payload.brief?.replace(/\n/gi, '<br>')" />
      </div>
      <br>
      <div class="van-hairline--bottom" />
      <br>
      <div class="com-form-wrap">
        <van-form ref="form">
          <van-field
            class="field-yellow"
            v-model="form.location.name"
            readonly
            clickable
            colon
            label="殿堂选择"
            placeholder="请选择殿堂"
            :rules="[{ required: true, message: '请选择殿堂' }]"
            @click="showPicker = true"
          />
          <van-field
            class="field-yellow"
            label="供灯时间"
            readonly
            colon
          >
            <template #input>{{ payload.date }}</template>
          </van-field>
          <van-field
            label="供灯数量"
            colon
          >
            <template #input>
              <van-stepper v-model="form.quantity" />
            </template>
          </van-field>
        </van-form>
        <br>
        <div class="com-form-submit">
          <DefaultBtn @click="unifiedOrder">登记信息</DefaultBtn>
        </div>
      </div>
    </div>
  </div>
  <Dictionary typeCode="gongdengdiantang" :show="showPicker" :selectDict="selectLocation" :close-on-click-overlay="false" position="bottom" />
</template>

<script>
  import Dictionary from '@/components/common/Dictionary'
  export default {
    props: {
      payload: Object,
      default: () => {}
    },
    data () {
      return {
        form: {
          location: {
            name: null,
            value: null
          },
          quantity: 1
        },
        showPicker: false
      }
    },
    methods: {
      // 跳转登记信息页面
      unifiedOrder () {
        this.$refs.form.validate().then(err => {
          if (!err) {
            // 以时间戳为key，存储页面数据
            const timestamp = Date.now()

            localStorage.setItem(timestamp, JSON.stringify({
              // 日常供灯
              type: 4,
              price: this.payload.price,
              quantity: this.form.quantity,
              pId: this.payload.id,
              gongdengdiantang: this.form.location.value,
              pageData: {
                ...this.payload,
                name: `${this.payload.name} - ${this.form.location.name}`
              }
            }))
            this.$router.push({
              path: 'record',
              query: { timestamp, type: 4}
            })
          }
        })
      },
      selectLocation (v) {
        if(v) {
          this.form.location.name = v.dictLabel
          this.form.location.value = v.dictValue
        }
        this.showPicker = false
      }
    },
    components: {
      Dictionary
    }
  }
</script>
